module.exports = __webpack_public_path__ + "static/media/ic-baseline-pool.7b4fd56b.svg";